"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//TODO: Add size type
function getHeaderBiddingInlineStyle(sizes) {
    if (!sizes) {
        throw new Error("No Size Detected");
    }
    // for multiple sizes, we return the width with height: auto, since the height of the creative
    // that will be injected isn't known
    if (sizes.length > 1) {
        var maxVal = 0;
        for (var _i = 0, sizes_1 = sizes; _i < sizes_1.length; _i++) {
            var size = sizes_1[_i];
            if (size[0] > maxVal) {
                maxVal = size[0];
            }
        }
        return 'style="width:' + maxVal + 'px;height:auto;"';
        // if there exactly one size, then we (should) be safe setting the height as well
    }
    else if (sizes.length === 1) {
        return 'style="width:' + sizes[0][0] + "px;height:" + sizes[0][1] + 'px;"';
    }
    // if there are no sizes at all, error. }
    throw new Error("Invalid Size Detected");
}
exports.default = getHeaderBiddingInlineStyle;
